import type { ModelDocument, QuantitySummary } from './types';

export function calculateQuantities(document: ModelDocument): QuantitySummary {
  const result: QuantitySummary = {
    entityCount: document.entities.length,
    wallCount: 0,
    wallLength: 0,
    grossWallArea: 0,
    netWallArea: 0,
    openingArea: 0,
    slabArea: 0,
    slabVolume: 0,
    boxVolume: 0,
  };

  for (const entity of document.entities) {
    if (!entity.visible) continue;
    const scale = entity.scale;
    const width = entity.dimensions.width * Math.abs(scale[0]);
    const height = entity.dimensions.height * Math.abs(scale[1]);
    const depth = entity.dimensions.depth * Math.abs(scale[2]);

    if (entity.kind === 'wall') {
      result.wallCount += 1;
      result.wallLength += width;
      result.grossWallArea += width * height;
      const openingArea = (entity.openings ?? []).reduce(
        (sum, opening) => sum + Math.max(0, opening.width) * Math.max(0, opening.height),
        0,
      );
      result.openingArea += openingArea;
      result.netWallArea += Math.max(0, width * height - openingArea);
    } else if (entity.kind === 'slab') {
      result.slabArea += width * depth;
      result.slabVolume += width * depth * height;
    } else if (entity.kind === 'box' || entity.kind === 'column') {
      result.boxVolume += width * height * depth;
    }
  }

  return result;
}
